(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chispa-subscription-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const cards = () =>
      document.querySelectorAll('[data-chispa-subscription-card]');

    const readCookie = (name) => {
      const prefix = `${name}=`;
      const value = document.cookie
        .split(';')
        .map((part) => part.trim())
        .find((part) => part.startsWith(prefix));
      return value ? decodeURIComponent(value.slice(prefix.length)) : '';
    };

    const saveMetaAttribution = () => {
      const params = new URLSearchParams(window.location.search);
      const fbp = readCookie('_fbp');
      let fbc = readCookie('_fbc');
      const fbclid = params.get('fbclid');

      if (!fbc && fbclid) {
        fbc = `fb.1.${Date.now()}.${fbclid}`;
      }

      if (fbp) localStorage.setItem('chispa_meta_fbp', fbp);
      if (fbc) localStorage.setItem('chispa_meta_fbc', fbc);
      localStorage.setItem('chispa_subscription_source_url', window.location.href);
    };

    const findVariantId = (card) => {
      const container = card.closest('section') || document;
      const variantInput = container.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      );

      return String(
        variantInput?.value ||
        card.dataset.initialVariantId ||
        ''
      );
    };

    const updateCard = (card) => {
      const frequencySelect = card.querySelector(
        '[data-chispa-subscription-frequency]'
      );
      const intervalDays = frequencySelect?.value === '45' ? '45' : '30';
      const linksElement = card.querySelector(
        `[data-chispa-subscription-links-${intervalDays}]`
      );
      const links = JSON.parse(linksElement?.textContent || '{}');
      const variantId = findVariantId(card);
      const subscriptionUrl =
        links[variantId] ||
        (intervalDays === '45'
          ? card.dataset.productSubscriptionUrlFortyFive
          : card.dataset.productSubscriptionUrlThirty) ||
        '';
      const button = card.querySelector(
        '.chispa-subscription-card__button'
      );
      const frequencyCopy = card.querySelector(
        '[data-chispa-subscription-frequency-copy]'
      );

      card.hidden = !subscriptionUrl;

      if (!button || !subscriptionUrl) return;

      button.href = subscriptionUrl;
      button.dataset.subscriptionVariantId = variantId;
      button.dataset.subscriptionIntervalDays = intervalDays;
      if (frequencyCopy) {
        frequencyCopy.textContent =
          `Se cobra y despacha cada ${intervalDays} días`;
      }
    };

    const updateAllCards = () => cards().forEach(updateCard);

    if (!window.chispaSubscriptionSelectorReady) {
      window.chispaSubscriptionSelectorReady = true;

      document.addEventListener('change', () => {
        window.setTimeout(updateAllCards, 0);
      });

      document.addEventListener('click', (event) => {
        const button = event.target.closest(
          '.chispa-subscription-card__button'
        );

        if (!button) return;

        saveMetaAttribution();

        const card = button.closest(
          '[data-chispa-subscription-card]'
        );

        updateCard(card);

        localStorage.setItem(
          'chispa_subscription_variant',
          button.dataset.subscriptionVariantId
        );

        localStorage.setItem(
          'chispa_subscription_product',
          button.dataset.subscriptionProductHandle
        );

        localStorage.setItem(
          'chispa_subscription_interval_days',
          button.dataset.subscriptionIntervalDays || '30'
        );
      });

      document.addEventListener(
        'shopify:section:load',
        updateAllCards
      );
    }

    saveMetaAttribution();
    updateAllCards();
  })();
  } catch(e) { console.error(e); }
})();

})();
